const useSDataGridStyles = () => {
    return {
        filterSearchStyles: {
            '& .MuiOutlinedInput-root': {
                background: (theme) => theme.palette.background.paper
            }
        }
    };
};
export default useSDataGridStyles;
